/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Verify_LoadingInputs */

const en_verify_loading = /** @type {(inputs: Verify_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verifying Ticket…`)
};

const es_verify_loading = /** @type {(inputs: Verify_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verificando Ticket…`)
};

const fr_verify_loading = /** @type {(inputs: Verify_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vérification du ticket…`)
};

const de_verify_loading = /** @type {(inputs: Verify_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ticket wird verifiziert…`)
};

const id_verify_loading = /** @type {(inputs: Verify_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Memverifikasi Tiket…`)
};

/** @type {(inputs: Verify_LoadingInputs) => LocalizedString} */
const ja_verify_loading = en_verify_loading;

/** @type {(inputs: Verify_LoadingInputs) => LocalizedString} */
const zh_verify_loading = en_verify_loading;

/** @type {(inputs: Verify_LoadingInputs) => LocalizedString} */
const ar_verify_loading = en_verify_loading;

/** @type {(inputs: Verify_LoadingInputs) => LocalizedString} */
const it_verify_loading = en_verify_loading;

/** @type {(inputs: Verify_LoadingInputs) => LocalizedString} */
const ru_verify_loading = en_verify_loading;

/** @type {(inputs: Verify_LoadingInputs) => LocalizedString} */
const pt_verify_loading = en_verify_loading;

/** @type {(inputs: Verify_LoadingInputs) => LocalizedString} */
const ko_verify_loading = en_verify_loading;

/**
* | output |
* | --- |
* | "Verifying Ticket…" |
*
* @param {Verify_LoadingInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const verify_loading = /** @type {((inputs?: Verify_LoadingInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Verify_LoadingInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_verify_loading(inputs)
	if (locale === "es") return es_verify_loading(inputs)
	if (locale === "fr") return fr_verify_loading(inputs)
	if (locale === "de") return de_verify_loading(inputs)
	if (locale === "ja") return ja_verify_loading(inputs)
	if (locale === "zh") return zh_verify_loading(inputs)
	if (locale === "ar") return ar_verify_loading(inputs)
	if (locale === "id") return id_verify_loading(inputs)
	if (locale === "it") return it_verify_loading(inputs)
	if (locale === "ru") return ru_verify_loading(inputs)
	if (locale === "pt") return pt_verify_loading(inputs)
	return ko_verify_loading(inputs)
});